import React, { useState, useEffect, useRef, memo } from 'react';

/**
 * HeaderGameSelector: Isolated component for selecting the game mode.
 * Encapsulates its own 'open' state to prevent full-page re-renders during interaction.
 */
const GAME_MODE_LABELS = {
  klassiekers: 'Klassiekerspel',
  giro: "Giro d'Italia",
  tour: 'Tour de France'
};

const HeaderGameSelector = memo(({ gameMode, onGameModeChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  // Click-outside listener
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleSelect = (mode) => {
    if (mode !== gameMode) {
      onGameModeChange({ target: { value: mode } });
    }
    setIsOpen(false);
  };

  return (
    <div className="game-mode-selector-container" ref={containerRef}>
      <button
        className="game-mode-trigger"
        onClick={() => setIsOpen(!isOpen)}
        title="Wissel van spelmodus"
      >
        {GAME_MODE_LABELS[gameMode] || GAME_MODE_LABELS.klassiekers}
        <span className={`selector-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </button>
      
      {isOpen && (
        <div className="game-mode-dropdown">
          <button
            className={`game-mode-item ${gameMode === 'klassiekers' ? 'active' : ''}`}
            onClick={() => handleSelect('klassiekers')}
          >
            Klassiekerspel
          </button>
          <button
            className={`game-mode-item ${gameMode === 'giro' ? 'active' : ''}`}
            onClick={() => handleSelect('giro')}
          >
            Giro d'Italia
          </button>
          <button
            className={`game-mode-item ${gameMode === 'tour' ? 'active' : ''}`}
            onClick={() => handleSelect('tour')}
          >
            Tour de France
          </button>
        </div>
      )}
    </div>
  );
});

export default HeaderGameSelector;
